import {useEffect} from "react";

const PROBE_STYLE =
  "position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none;z-index:-1;padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)";

function readProbeInsets(probe: HTMLDivElement) {
  const style = getComputedStyle(probe);
  return {
    right: Number.parseFloat(style.paddingRight) || 0,
    bottom: Number.parseFloat(style.paddingBottom) || 0,
    left: Number.parseFloat(style.paddingLeft) || 0,
  };
}

/**
 * Publishes horizontal/bottom --app-safe-area-* on :root for home indicator and notches.
 * Top inset is intentionally omitted: with an opaque iOS status bar the WebView already
 * starts below the status bar; extra top padding only creates a white band above the header.
 */
export default function useSafeAreaInsets() {
  useEffect(() => {
    const probe = document.createElement("div");
    probe.setAttribute("aria-hidden", "true");
    probe.style.cssText = PROBE_STYLE;
    document.documentElement.appendChild(probe);

    const apply = () => {
      const {right, bottom, left} = readProbeInsets(probe);

      document.documentElement.style.setProperty("--app-safe-area-top", "0px");
      document.documentElement.style.setProperty("--app-safe-area-right", `${right}px`);
      document.documentElement.style.setProperty("--app-safe-area-bottom", `${bottom}px`);
      document.documentElement.style.setProperty("--app-safe-area-left", `${left}px`);
    };

    apply();

    window.addEventListener("orientationchange", apply);
    window.addEventListener("resize", apply);

    return () => {
      probe.remove();
      window.removeEventListener("orientationchange", apply);
      window.removeEventListener("resize", apply);
      document.documentElement.style.removeProperty("--app-safe-area-top");
      document.documentElement.style.removeProperty("--app-safe-area-right");
      document.documentElement.style.removeProperty("--app-safe-area-bottom");
      document.documentElement.style.removeProperty("--app-safe-area-left");
    };
  }, []);
}
